<script setup lang="ts">
import { useQuery } from "@tanstack/vue-query";
import { ArticleInclude, getArticleRelatedArticles } from "../../repository";
import ArticleCard from "../ArticleCard.vue";
import { computed, toRef } from "vue";
import { ErrorState } from "../states";
import LoadingIndicator from "../general/LoadingIndicator.vue";

const props = defineProps<{
  articleId: string | number;
}>();

const { data, isLoading, refetch, isError } = useQuery({
  queryKey: ["relatedArticles", toRef(props, "articleId")],
  queryFn: () =>
    getArticleRelatedArticles(props.articleId, {
      cursor: "null",
      include: [ArticleInclude.Edition],
    }),
});

const relatedArticles = computed(() => {
  return data.value?.data.data;
});
</script>

<template>
  <div v-if="isLoading || isError" class="flex-center min-h-[297px]">
    <LoadingIndicator v-if="isLoading" class="text-icon-brand" />
    <ErrorState
      v-else-if="isError"
      :contentName="$t('common.articles')"
      @refetch="refetch"
    />
  </div>
  <div v-else-if="data" class="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <ArticleCard
      v-for="article in relatedArticles"
      :key="article.id"
      :article="article"
    />
  </div>
</template>
